var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 24,
    viewBox: "0 0 36 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4570_54115)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 3C0 1.34315 1.34315 0 3 0H33C34.6569 0 36 1.34315 36 3V21C36 22.6569 34.6569 24 33 24H3C1.34315 24 0 22.6569 0 21V3Z",
    fill: "#FDEACE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7546 4.89524L14.0078 4.92188L14.2426 19.1042L21.9893 19.0776L21.7546 4.89524Z",
    fill: "#FF5F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5163 12.0411C14.4683 9.15657 15.7605 6.5935 17.7845 4.93098C16.2568 3.73214 14.3415 3.01124 12.2653 3.01835C7.34661 3.0352 3.4343 7.08724 3.51725 12.0788C3.6002 17.0704 7.64674 21.0952 12.5654 21.0783C14.6416 21.0712 16.5327 20.3373 18.0205 19.1281C15.9419 17.5047 14.5642 14.9257 14.5163 12.0411Z",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4806 11.9182C32.5636 16.9098 28.6513 20.9618 23.7326 20.9787C21.6564 20.9858 19.7411 20.2649 18.2133 19.0661C20.262 17.4035 21.5295 14.8405 21.4816 11.9559C21.4337 9.07131 20.0564 6.51739 17.9774 4.86892C19.4651 3.65976 21.3563 2.92582 23.4325 2.91871C28.3511 2.90186 32.3981 6.95173 32.4806 11.9182Z",
    fill: "#F79E1B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4570_54115"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.261775fd65d4aff3ac2b17731d0daf9e.svg";
export { ForwardRef as ReactComponent };